module.exports = __webpack_public_path__ + "media/material-kit/img/arrow-left-5b6695a040c69f4e17023b945cd6e2d8.png";